import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { BreadcrumbModule, ModalModule, TableModule, EmptyStateModule, IconModule, TimepickerModule } from '@michelin/theme';
import { SharedModule } from '../../shared/shared.module';
import { AdministrationScreenComponent } from './components/administration-screen/administration-screen.component';
import { NotificationsManagementComponent } from './components/notifications-management/notifications-management.component';
import { NotificationBannerAdminComponent } from './components/notification-banner-admin/notification-banner-admin.component';
import { NotificationBannerEditorComponent } from './components/notification-banner-editor/notification-banner-editor.component';

@NgModule({
  declarations: [
    AdministrationScreenComponent,
    NotificationsManagementComponent,
    NotificationBannerAdminComponent,
    NotificationBannerEditorComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatTooltipModule,
    MatTabsModule,
    MatTableModule,
    MatMenuModule,
    BreadcrumbModule,
    ModalModule,
    TableModule,
    EmptyStateModule,
    IconModule,
    TimepickerModule,
    SharedModule
  ],
  exports: [AdministrationScreenComponent]
})
export class AdministrationModule {}
